import Container from './Container'
import { ContainerType } from './ContainerType'
import { playerDims } from '../utils'

export default class DockedBottomContainer extends Container {
  constructor () {
    super(ContainerType.DOCKED_BOTTOM, false)
  }

  style (bid, slot, media) {
    const container = slot.container()

    container.style.position = 'fixed'
    container.style.width = '100%'
    container.style.display = 'flex'
    container.style['justify-content'] = 'center'
    container.style.bottom = '0px'
    slot.node().style.display = 'flex'
    slot.node().style['justify-content'] = 'center'
    slot.node().style['z-index'] = '999'

    const dims = playerDims(media, bid)
    if (dims && dims[0] !== 1) {
      // if 1x1 its native, need to amend to use max dims then
      container.style.width = '100%' // dims[0] + 'px'
      container.style.height = (dims[1] + 10) + 'px' // reserve space for buttons
      container.style.margin = '0px'
      container.style.border = 'none'
    }

    /* required to position buttons properly */
    slot.node().style.position = 'absolute'
    slot.node().style.bottom = '0px'
  }
}
